import React, { useCallback, useState } from "react";
import HeaderBrand from "@/components/HeaderBrand";

/** Önce `/public/brand/header-logo.webp`; yoksa veya hata → HeaderBrand. */
export default function HeaderLogo() {
  const [useFallback, setUseFallback] = useState(false);

  const onError = useCallback(() => {
    setUseFallback(true);
  }, []);

  if (useFallback) {
    return <HeaderBrand />;
  }

  const base = process.env.PUBLIC_URL || "";

  return (
    <img
      src={`${base}/brand/header-logo.webp`}
      alt="CommodityBid — Find The Best Price"
      className="h-12 sm:h-14 md:h-[4.75rem] w-auto max-w-[min(100vw-10rem,400px)] object-contain object-left block bg-transparent"
      loading="eager"
      decoding="async"
      onError={onError}
    />
  );
}
